import { ServiceResponse } from '../types';
import Request from './Request';
import axios, { AxiosResponse, AxiosError } from 'axios';

/**
 * Class Service
 * Work with http-client
 */
export default class Service<TResponseSuccessBody, TResponseErrorBody> {
  public constructor(private request: Request<unknown>) {}

  public async send(): Promise<
    ServiceResponse<TResponseSuccessBody, TResponseErrorBody>
  > {
    try {
      const response = await this.axiosInstance();
      return { status: response.status, body: response.data, error: null };
    } catch (e) {
      const error = e as AxiosError<TResponseErrorBody>;
      if (error.response) {
        return {
          status: error.response.status,
          error: error.response.data,
          body: null
        };
      }
      return {
        error: null,
        body: null
      };
    }
  }

  /**
   * fabric for axios instances
   */
  private axiosInstance(): Promise<AxiosResponse<TResponseSuccessBody>> {
    const headers = {} as { [index: string]: string };
    if (this.request) {
      this.request.headers.forEach(header => {
        headers[header.name] = header.value;
      });
    }

    switch (this.request.method) {
      case 'GET':
        return axios.get<TResponseSuccessBody>(this.request.url, {
          params: this.request ? this.request.payload : {},
          headers
        });
      case 'POST':
        return axios.post<TResponseSuccessBody>(
          this.request.url,
          this.request ? this.request.payload : {},
          {
            headers
          }
        );
      case 'DELETE':
        return axios.delete<TResponseSuccessBody>(this.request.url, {
          params: this.request ? this.request.payload : {},
          headers
        });
    }
  }

  public getRequest() {
    return this.request;
  }
}
